import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DischargeSummaryComponent} from './discharge-summary.component';

const routes: Routes = [
  {
    path: '', component: DischargeSummaryComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary/discharge-summary.routing.ts